"use client";

import { useId } from "react";
import { useT } from "@/lib/locale";

interface ComingSoonPillProps {
  label: string;
  note?: string;
  className?: string;
}

export default function ComingSoonPill({
  label,
  note,
  className = "",
}: ComingSoonPillProps) {
  const t = useT();
  const noteId = useId();
  // Default roadmap note is i18n-keyed; callers may still pass a localized override.
  const resolvedNote = note ?? t("common.deliveryRoadmap");

  return (
    <span
      role="button"
      aria-disabled="true"
      aria-describedby={noteId}
      tabIndex={0}
      className={[
        "inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium",
        "text-neutral-500 bg-neutral-100 border border-neutral-200 cursor-not-allowed",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2",
        className,
      ].join(" ")}
    >
      {label}
      <span
        id={noteId}
        className="inline-flex items-center rounded-full bg-neutral-200 px-2 py-0.5 text-[10px] font-semibold text-neutral-500 uppercase tracking-wider"
      >
        {resolvedNote}
      </span>
    </span>
  );
}
